module.exports = __webpack_public_path__ + "static/Germany-f1c6d094c3aa1f4c33054f451f84f7ca.jpg";